module.exports = __webpack_public_path__ + "img/bullhorn.f60c5a2b.svg";